import {Component, inject} from '@angular/core';
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-information-dialog',
    imports: [
        MatDialogContent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TranslateModule
    ],
    templateUrl: './information-dialog.component.html',
    styleUrl: './information-dialog.component.scss'
})
export class InformationDialogComponent {
  readonly dialogRef = inject(MatDialogRef<InformationDialogComponent>);

}
